'use es6';

export const get = (spec, config) => {
  const {
    offset
  } = config;
  return {
    offset
  };
};